document.addEventListener('DOMContentLoaded', function () {
  const headerElement = document.querySelector('.header_wrapper');
  const submenuElement = document.querySelector('.submenu');

  if (headerElement && submenuElement) {
    const headerWrapperCurrentHeight = headerElement.offsetHeight;
    submenuElement.style.top = `${headerWrapperCurrentHeight}px`;
  }
});